// removed by extract-text-webpack-plugin
module.exports = {"slogan":"_2PH7RSzVF5eheYEYIwy0UG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/slogan/Slogan.css
// module id = 345
// module chunks = 0